// export const BASEURL="https://ekomm.herokuapp.com";
export const BASEURL="https://e-comm-bnw8.onrender.com"
export const CLIENTURL="https://buyfromhere.netlify.app";
